import { graphql } from "gatsby";
import React from "react";
import ArticleTemplate from "../../templates/Article/Article";

const Video = ({ location, data: { allArticles, article } }) => {
  const { href: url } = location;
  return (
    <ArticleTemplate article={article} allArticles={allArticles} url={url} />
  );
};

export default Video;

export const query = graphql`
  query GetVideo($slug: String) {
    article: strapiInsights(slug: { eq: $slug }) {
      metaData {
        pageTitle
        metadescription
      }
      multiComponent
      id
      published_at
      publish_at
      authors {
        id
        name
        published_at
      }
      client_types {
        Type
      }
      copy
      featureVideo {
        id
        title
        video {
          localFile {
            publicURL
          }
        }
        transcript {
          localFile {
            id
            publicURL
          }
        }
        poster {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1440)
            }
          }
        }
      }
      image {
        longDesc
        image {
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 1440)
            }
            publicURL
          }
          url
        }
      }
      media_type {
        tyoe
      }
      shortDesc
      subtitle
      slug
      continueReading {
        articlesHeading
        insights {
          id
          copy
          publish_at
          shortDesc
          slug
        }
        case_studies {
          id
        }
        events {
          id
        }
        press_releases {
          id
        }
      }
    }

    allArticles: allStrapiInsights(
      filter: { media_type: { tyoe: { eq: "Article" } } }
    ) {
      nodes {
        authors {
          id
          name
          published_at
        }
        id
        shortDesc
        slug
        subtitle
        media_type {
          tyoe
        }
        image {
          image {
            alternativeText
            localFile {
              childImageSharp {
                gatsbyImageData(height: 80, width: 122)
              }
            }
          }
        }
      }
    }
  }
`;
